import { Outlet, Navigate } from '@tanstack/react-router'

export const Route = createFileRoute({
  component: AdminLayout,
})

function AdminLayout() {
  // If at exactly /admin, redirect to /admin/users
  if (window.location.pathname === '/admin') {
    return <Navigate to="/admin/users" replace />
  }

  // Render children (users routes, etc.)
  return <Outlet />
}
